module.exports = __webpack_public_path__ + "media/images/profile-81b79f39dd54d7500d7f15eb060250f2.jpg";